module.exports = __webpack_public_path__ + "static/sysco-sample-ac00fd903742a172cbbaef3ff764d406.png";